import { type RichiestaModuloDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTO.ts';
import { mapSubmissionModuleState } from '@framework/common-web/frontoffice/module/fsm/mapSubmissionModuleState.ts';
import { type IFrontOfficeModule } from '@framework/common-web/frontoffice/module/IFrontOfficeModule.ts';
import { sortBy } from 'lodash';
import { useMemo } from 'react';

export interface IUseFrontOfficeModuleParams {
  data: RichiestaModuloDTO | undefined;
}

export type IUseFrontOfficeModuleResult = ReturnType<
  typeof useFrontOfficeModule
>;

/**
 * Mappa i moduli tornati dall'API a un formato utilizzabile per il frontoffice
 */
export function useFrontOfficeModule(
  params: IUseFrontOfficeModuleParams,
): IFrontOfficeModule | null {
  const { data } = params;

  return useMemo(() => {
    const module = data?.modulo?.modulo;
    const sections = data?.modulo?.sezioni;
    if (!module) return null;

    return {
      moduloRichiestaId: data.id,
      domandaModulo: data?.domandaModulo,
      ...module,
      permessi: data.permessi,
      idFileFirmato: data.idFileFirmato,
      statoValidazione: data.statoValidazione,
      valori: data.valoriSezioni,
      sezioni: sortBy(sections, 'ordine'),
      stato: mapSubmissionModuleState(data.statoCompilazione),
      titoloModuloDinamico: data.titoloModuloDinamico,
      fattispecie: data.fattispecie,
      fattispecieAttivante: data.fattispecieAttivante,
    };
  }, [data]);
}
